module.exports = __webpack_public_path__ + "static/media/3_square.a8f202e1.png";